import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Helmet} from "react-helmet";
import { styled } from "@mui/material/styles";
import coverBackground from './../assets/static/images/lob-5612-banner-group.jpg'
import client1 from './../assets/static/images/client1.png';
import client2 from './../assets/static/images/client2.png';
import client4 from './../assets/static/images/client4.png';
import client5 from './../assets/static/images/client5.png';
import FormDialog from "./FormDialogueComponent";
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Divider from '@material-ui/core/Divider';
import { usePromiseTracker } from "react-promise-tracker";
import { trackPromise } from 'react-promise-tracker';

import { withStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';

import {headSection, cardsData, howWeHelp, jobsData, charitableCardsData} from './configs/HomeData';

import LinearProgress from "@material-ui/core/LinearProgress";
import Loader from 'react-loader-spinner';
import MetaHead from "../shared/MetaHead";
import ContactForm from "./ContactForm";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ExampleTextField = styled(TextField)({
  backgroundColor: "#eee",
  "& .MuiFormControl-root": {
    borderRadius: "4px"
  },
  "& .MuiFormLabel-root.Mui-focused": {
    color: "#a61930",
    backgroundColor: "white",
    padding: "2px",
    borderRadius: "4px"
  },
  // "&.Mui-focused": {
  //   "& .MuiOutlinedInput-notchedOutline": {
  //     border: "none"
  //   }
  // }
});

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    // backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(14, 0, 16),
    marginTop: '140px',
    backgroundImage: `url(${coverBackground})`,
    backgroundColor: 'rgba(0,0,0,0.5)',
    backgroundBlendMode: 'soft-light',
    backgroundSize: 'cover',
    backgroundPosition: 'center',

  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  textFields: {
    backgroundColor: 'white'
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(2),
  },
  card: {
    height: '100%',
    display: 'flex',
    backgroundColor: '#f5f9fc',
    flexDirection: 'column',
    border: '2px solid #e6f8fb',
    borderRadius: '8px',
    // boxShadow: '0 1px 3px 0 rgba(37,32,31,.3)',
    // boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;'
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
    borderRadius: '8px',
    // backgroundSize: 'contain',
    margin: '15px',
    // marginTop: '20px',
  },
  cardContent: {
    flexGrow: 1,
    padding: "24px",

  },
   root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '30ch',
    },
  },
  buttonStyle: {
    width: '30ch'
  },
  drop: {
    width: '30ch',
    margin: '8px',
    paddingTop: '15px',
  },
  footer: {
    backgroundColor: '#2f3030',
    padding: theme.spacing(6),
    color: theme.palette.background.paper,
  },
  preFooter: {
    backgroundColor: '#dfe0e0',
    padding: theme.spacing(4),
    color: theme.palette.background.paper,
  },
}));

const WhiteTextTypography = withStyles({
  root: {
    color: "#3a3b3b"
  }
})(Typography);


export default function Home() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState("success")
  const [notificationMessage, setNotificationMessage] = React.useState("Form submitted! Check your inbox for your first question")
  const [postcode, setPostcode] = React.useState('');
  const [isLoaded, setIsLoaded] = useState(false);

  const [openForm, setOpenForm] = useState(false);

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const vertical = 'top';
  const horizontal = 'center';


  const handleButtonClick = (page) => {
    handleNavigate(page)

  };

  useEffect(() => {
    window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
  },[]);

  let history = useHistory();

  function handleNavigate(page) {
    if (page === 'services') {
      history.push({
        pathname: '/about-us',
      });
    }
    if (page === 'contact') {
      history.push({
        pathname: '/contact',
      });
    }
    if (page === 'vacancies') {
      history.push({
        pathname: '/vacancies',
      })
    }

  }


  return (
    <React.Fragment>
      <MetaHead/>
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{vertical, horizontal}}
          key={vertical + horizontal}
        >
          <Alert onClose={handleClose} severity={severity}>
            {notificationMessage}
          </Alert>
        </Snackbar>

        {/*Form Dialog*/}
        <FormDialog
          openForm={openForm}
          handleFormClose={handleCloseForm}
          postcode={postcode}
        />

        {isLoaded ?
          <Container maxWidth="md">
            <div>
              <LinearProgress />
            </div>
          </Container>
          :
            null
        }
        <div className={classes.heroContent}>
          <Container maxWidth="sm">

            {/*</div>*/}
            <div style={{textAlign: 'center', padding: '16px 0px'}}>
              <Typography
                variant="h6"
                align="center"
                color="textPrimary"
                style={{ color: 'white', fontWeight: '500'}}
                gutterBottom>
                Welcome to
              </Typography>
            </div>
            <div style={{textAlign: 'center', padding: '16px 0px'}}>
              <Typography
                variant="h4"
                align="center"
                color="textPrimary"
                style={{ color: 'white', fontWeight: '600'}}
                gutterBottom>
                Lodge of Benevolence
              </Typography>
            </div>
            <div style={{textAlign: 'center'}}>
              <Typography
                variant="h4"
                color="textPrimary"
                style={{ color: '#e8d5b7', fontWeight: '600'}}
                gutterBottom>
                <span
                  // style={{backgroundColor: 'rgb(245, 195, 0)', padding: '0.0em 0.2em 0.0em 0.2em'}}
                >
                  {headSection.topTitle}</span>
              </Typography>
            </div>
            <hr className="hr-line"/>
            <div className={classes.heroButtons}>
              <Grid container spacing={2} justify="center">
                <Grid item xs={12} elevation={0} style={{ paddingBottom: '0px' }}>
                  <div
                    style={{
                      height: '100px',
                      marginBottom: '15px'
                    }}
                  >
                  </div>
                </Grid>
              </Grid>
            </div>
            {/*<div className={classes.heroButtons}>*/}
            {/*  <Grid container spacing={2} justify="center">*/}
            {/*    <Grid item xs={12} elevation={0} style={{ paddingBottom: '0px'}}>*/}
            {/*      <div>*/}
            {/*        <Typography*/}
            {/*          variant="h6"*/}
            {/*          align="center"*/}
            {/*          color="textPrimary"*/}
            {/*          style={{ color: 'white', fontWeight: '600', paddingBottom: '0px'}}*/}
            {/*          gutterBottom>*/}
            {/*          Seeking in-home care? </Typography>*/}
            {/*      </div>*/}
            {/*    </Grid>*/}
            {/*    <Grid item xs={12}>*/}
            {/*      <div style={{ textAlign: "center"}}>*/}
            {/*        <ExampleTextField*/}
            {/*          style={{ borderRadius: "4px", marginRight: "8px" }}*/}
            {/*          label="Enter your postcode"*/}
            {/*          size="small"*/}
            {/*          variant="outlined"*/}
            {/*          value={postcode}*/}
            {/*          onChange={(e) => setPostcode(e.target.value)}*/}
            {/*        />*/}
            {/*        <Button*/}
            {/*          variant="contained"*/}
            {/*          color="secondary"*/}
            {/*          onClick={() => setOpenForm(true)}*/}
            {/*        >*/}
            {/*          Go*/}
            {/*        </Button>*/}
            {/*      </div>*/}
            {/*    </Grid>*/}

            {/*  </Grid>*/}
            {/*</div>*/}
            <div style={{ display: 'None' }} className={classes.heroButtons}>
              <Grid container spacing={2} justify="center">
                <Grid item elevation={0} >
                  <Button variant="contained" color="secondary" onClick={() => handleButtonClick('services')}>
                    More Info
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined"
                          style={{color: 'white', border: '1px solid #fff'}}
                          onClick={() => handleButtonClick('contact')}
                  >
                    Get in Touch
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Container>
        </div>

        {/*Intro section*/}
        <Container className={classes.cardGrid} style={{paddingTop: '10px'}} maxWidth="md">
          <Typography
            component="h1"
            variant="h4"
            align="left"
            // className="title-header"
            style={{fontWeight: 'bold', marginBottom: '40px', marginTop: '64px'}}
            gutterBottom>
            We believe Freemasonry can bring a positive change into your life…
            </Typography>
          <div style={{textAlign: 'left', marginBottom: '0px'}}>
            <ol className="left">
              <Typography
                variant="body1" color="text.primary"
              >
                Historically Freemasonry had connections with Architecture, Building, Geometry and everything
                connected with the built environment. This is where it got part of its title “Masonry”.
                Today, we at Pudsey Masonic Hall and The Lodge of Benevolence No 5612, maintain the same connections
                with tradition but include all levels of society and all sectors of commerce and industry.
                We’re a mixture of ages and backgrounds coming together to share experience, strengths and abilities.
              </Typography>
            </ol>
            <ol className="center" style={{display: 'None'}}>
              <Typography>
                <a target="_blank" href="https://www.cqc.org.uk/location/1-12088474782">
                  Click here </a> to view our latest CQC report
              </Typography>
            </ol>
          </div>
        </Container>


        {/*Our Expertise*/}
        <Container className={classes.cardGrid} maxWidth="md">
          <Typography
            component="h1"
            variant="h4"
            align="left"
            style={{fontWeight: 'bold', marginBottom: '40px'}}
            gutterBottom>
            The Journey of a Mason Begins Here
          </Typography>
          <div>
            {/*Usually a section*/}
            {/*<Typography variant="body1" color="text.primary" style={{display: 'None'}}>*/}
            {/*</Typography>*/}
          </div>
          <Grid container spacing={4}>
            {cardsData.map((card) => (
              <Grid item key={card.id} xs={12} sm={6} md={3}>
                <Card className={classes.card} elevation={0}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={card.remote_image}
                    title="Image title"
                  />
                  <CardContent className={classes.cardContent}>
                    <Typography
                        gutterBottom
                        variant="h6"
                        component="h2"
                        style={{fontWeight: 'bold', textAlign: 'left'}}>
                      {card.title}
                    </Typography>
                    <Divider variant="middle" style={{ marginBottom: '15px', marginTop: '15px'}} />
                    <Typography  variant="body1" color="text.primary" style={{ textAlign: 'left'}}>
                      {card.desc}
                    </Typography>
                  </CardContent>
                  <CardActions style={{marginBottom: '20px', alignItems: 'center', justifyContent: 'center'}}>
                    <Button
                      size="small"
                      variant="contained"
                      color="secondary"
                      disableElevation
                      style={{fontWeight: 800}}
                      onClick={() => handleButtonClick('services')}>
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/*The Intro to Masonry video*/}
        <Container className={classes.cardGrid} maxWidth={"md"}>
          <Typography
            component="h1"
            variant="h4"
            align="left"
            style={{fontWeight: 'bold', marginBottom: '40px'}}
            gutterBottom>
            Discover Freemasonry
          </Typography>
          <Grid container spacing={4}>
          {/* Video */}
          <Grid item xs={12} md={10} lg={8} sx={{ mx: 'auto' }}>
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                paddingTop: '56.25%' /* 16:9 */,
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 3,
              }}
            >
              <Box
                component="iframe"
                src="https://www.youtube-nocookie.com/embed/stLrTAyOFh4"
                title="Lodge of Benevolence — Introduction"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                sx={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  border: 0,
                }}
              />
            </Box>
          </Grid>
        </Grid>

        </Container>

        {/*Charitable causes section*/}
        <Container className={classes.cardGrid} maxWidth="md">
          <Typography
            component="h1"
            variant="h4"
            align="left"
            style={{fontWeight: 'bold', marginBottom: '40px'}}
            gutterBottom>
            Our Charitable Causes
          </Typography>
          <Grid container spacing={4}>
            {charitableCardsData.map((card) => (
              <Grid item key={card.id} xs={12} sm={4} md={4}>
                <Card className={classes.card} elevation={0}>
                  <CardMedia
                    className={classes.cardMedia}
                    image={card.remote_image}
                    title="Image title"
                  />
                  <CardContent className={classes.cardContent}>
                    <Typography
                        gutterBottom
                        variant="h6"
                        component="h2"
                        style={{fontWeight: 'bold', textAlign: 'left'}}>
                      {card.title}
                    </Typography>
                    <Divider variant="middle" style={{ marginBottom: '15px', marginTop: '15px'}} />
                    <Typography  variant="body1" color="text.primary" style={{ textAlign: 'left'}}>
                      {card.desc}
                    </Typography>
                  </CardContent>
                  <CardActions style={{marginBottom: '20px', alignItems: 'center', justifyContent: 'center'}}>
                    <Button
                      size="small"
                      variant="contained"
                      color="secondary"
                      disableElevation
                      style={{fontWeight: 800}}
                      onClick={() => handleButtonClick('services')}>
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>


        {/*Contact us*/}
        <Container className={classes.cardGrid} maxWidth={"md"}>
          <Typography
            component="h1"
            variant="h4"
            align="left"
            style={{fontWeight: 'bold', marginBottom: '40px'}}
            gutterBottom>
            Contact us?
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <ContactForm headerText='Get in touch'/>
            </Grid>
            <Grid item xs={12} sm={6}>
              {/* Charities / partner logos */}
              <WhiteTextTypography
                component="h6"
                variant="h6"
                align="center"
                style={{ fontWeight: 'bold', marginTop: '8px', marginBottom: '16px' }}
              >
                We can’t help everyone, but everyone can help someone
              </WhiteTextTypography>

              <Box sx={{ px: { xs: 2, sm: 1 } }}>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                  {[
                    { src: client1, alt: 'Action for Charity' },
                    { src: client2, alt: 'Amores' },
                    { src: client4, alt: 'Charity Life' },
                    { src: client5, alt: 'Globe International' },
                  ].map(({ src, alt }, i) => (
                    <Grid key={i} item xs={6} sm={4} md={6}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: 2,
                          bgcolor: 'rgba(255,255,255,0.04)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: 96,
                          transition: 'transform 150ms ease, box-shadow 150ms ease',
                          '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: 3,
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={src}
                          alt={alt}
                          loading="lazy"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: 64,
                            objectFit: 'contain',
                            filter: 'grayscale(100%)',
                            opacity: 0.8,
                            transition: 'filter 200ms ease, opacity 200ms ease',
                            '&:hover': { filter: 'none', opacity: 1 },
                          }}
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>

              {/*Here I want to add the image logos of the various masonic charities we support, I have 5 images*/}

            </Grid>
          </Grid>
        </Container>


        {/* End Our Expertise*/}
      </main>
      {/* End footer */}

    </React.Fragment>
  );
}